import { useFormData } from '@/composables';
import type { Currency } from '@/types';

interface Commission {
    name: string
    amount: string,
    currency: Currency,
}

export function useCommission(serviceCommission: Commission, networkCommission: Commission, totalCommission: Commission) {
    const { state, change } = useFormData({
        service: serviceCommission,
        network: networkCommission,
        total: totalCommission,
    });

    const reset = () => {
        state.data.service.amount = '0.00';
        state.data.network.amount = '0.00';
        state.data.total.amount = '0.00';
    };

    return {
        commissions: state.data,
        change,
        reset,
    };
}
